// @ts-nocheck — TODO: tipizzare (estratto da clienti.js per ridurne la dimensione)
// ====== S4: filtro + ricerca Clienti (estratto da clienti.js) ======
// Contiene la logica di filtro tabellare e la ricerca fuzzy server-side.
// `renderClienti` (in clienti.js) chiama getFilteredClienti()/populateFilters();
// il listener di ricerca chiama maybeFuzzyServerSearch(). Tutte esposte su
// globalThis: i bare-identifier nei moduli risolvono sulle proprietà globali.
//
// Importato PRIMA di clienti.js in main.js.

// Cache risultati ricerca server-side (fuzzy)
let _searchFuzzyIds = null;
let _searchDebounce = null;

function getFilteredClienti() {
  const search = ($('#clientiSearch')?.value || '').toLowerCase().trim();
  const cpl = $('#filterPM').value;
  const per = $('#filterAmbiente').value;
  const res = $('#filterRisorsa').value;
  const sta = $('#filterStato').value;
  return state.clients.filter((c) => {
    if (search) {
      const haystack = [
        c.nome,
        c.cpl,
        c.pm1,
        c.pm2,
        c.serviceLineRef,
        c.tenantId,
        c.note,
        c.ruolo,
        (c.perimetri || []).join(' '),
        (c.tecnici || []).join(' '),
        c.contratto?.numero,
        c.contratto?.tipo
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      const localHit = haystack.includes(search);
      // Se ho risultati fuzzy dal server, prendi anche quelli (fuzzy match)
      const fuzzyHit = _searchFuzzyIds && _searchFuzzyIds.has(c._id);
      if (!localHit && !fuzzyHit) return false;
    }
    if (cpl && c.cpl !== cpl && c.pm1 !== cpl && c.pm2 !== cpl) return false;
    if (per && !(c.perimetri || []).includes(per)) return false;
    if (res) {
      if (!c.accessi || !c.accessi[res]) return false;
      if (sta && c.accessi[res] !== sta) return false;
    } else if (sta) {
      if (!Object.values(c.accessi || {}).some((v) => v === sta)) return false;
    }
    return true;
  });
}

// Debounced fuzzy search server-side
async function maybeFuzzyServerSearch(q) {
  clearTimeout(_searchDebounce);
  if (!q || q.length < 3) {
    _searchFuzzyIds = null;
    return;
  }
  _searchDebounce = setTimeout(async () => {
    try {
      const { data, error } = await sb.rpc('search_clienti', { q });
      if (error) {
        _searchFuzzyIds = null;
        return;
      }
      _searchFuzzyIds = new Set((data || []).map((r) => r.id));
      renderClienti();
    } catch {
      _searchFuzzyIds = null;
    }
  }, 250);
}

function populateFilters() {
  const cplSet = new Set();
  state.clients.forEach((c) => {
    if (c.cpl) cplSet.add(c.cpl);
    if (c.pm1) cplSet.add(c.pm1);
    if (c.pm2) cplSet.add(c.pm2);
  });
  const cpls = [...cplSet].sort();
  fillSelect($('#filterPM'), cpls, 'Tutti CPL/PM');
  fillSelect($('#filterAmbiente'), PERIMETRI, 'Tutti i perimetri');
  fillSelect($('#filterRisorsa'), state.resources, 'Tutte le risorse');
  $('#pmList').innerHTML = cpls.map((p) => `<option value="${escapeHtml(p)}">`).join('');
}

Object.assign(globalThis, { getFilteredClienti, maybeFuzzyServerSearch, populateFilters });
export {};
